import React, {useCallback, useEffect, useRef, useState} from 'react';

// this hook now returns a callback ref, so the element is observed
// whenever it is rendered, including when it only shows up after
// the first render
export const useResizeObserver = (
    callback: (
        entries: ResizeObserverEntry[],
        container: React.MutableRefObject<HTMLDivElement>
    ) => void
) => {
    const ref = useRef<HTMLDivElement>(null);
    const [element, setElement] = useState<HTMLDivElement | null>(null);

    const setRef = useCallback((node: HTMLDivElement | null) => {
        ref.current = node;
        setElement(node);
    }, []);

    useEffect(() => {
        if (!element) return;

        const observer = new ResizeObserver((entries) => {
            if (entries.length > 0 && ref.current) {
                callback(entries, ref);
            }
        });

        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [element, callback]);

    return setRef;
};
